<div class="reference-point-input-container">
    <div style="flex: 1;">
        <input type="text" class="reference-point-input" 
            placeholder="Buscar Ubicación" 
            [(ngModel)]="locationIdentifier"
            (input)="onSearchInput()"
            (keyup.enter)="searchLocation()"
            (focus)="onInputFocus()"
            (blur)="onInputNoFocus()"
            [disabled]="isSearchDisabled"
            autocomplete="off">

        <div class="directions-list" *ngIf="inputFocused && showSuggestions && locationSuggestions.length > 0">
            <div class="directions-item" *ngFor="let suggestion of locationSuggestions" (click)="selectSuggestion(suggestion)">

                <div class="directions-data">
                    <div class="directions-name">{{ suggestion.identifier }}</div>
                    <!-- <div class="directions-place">{{ suggestion.pedirDescripcion o algo si se ocupa }}</div> -->
                </div>

            </div>
        </div>
    </div>
</div>